module.exports = __webpack_public_path__ + "img/stu_rings1.539cd638.png";